module.exports = __webpack_public_path__ + "media/app/javascript/images/valid-331645038a1c799a30cf66ef8bccc069.svg";